<template>
  <div class="detail-page">
    <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      :title="name || '课程详情'"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
    <van-popup v-model="show" position="bottom">
      <div class="share-box">
        <div
          @click="
            show2 = true;
            show = false;
          "
        >
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share3.png"
            alt=""
          />
          微信
        </div>
        <div @click="copy">
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share2.png"
            alt=""
          />
          复制链接
        </div>
      </div>
    </van-popup>
    <div class="share-wrap" @click="show2 = false" v-show="show2">
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share1.png"
        alt=""
      />
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share4.png"
        alt=""
      />
    </div>
    <div class="video-wrap">
      <div class="coverImg">
        <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2限免，1不限免-->
        <!-- <div class="tip">
          
          <img :src="$free" v-if="is_free==2"/>
          <img :src="$vip" v-else-if="is_vip==1"/>
          <img :src="$noVip" v-else>
        </div> -->
        <van-image class="price-cover"  v-show="!playId" fit="cover" 
        :error-icon="$placeImg"
        :loading-icon="$placeImg"
        :src="cover" alt=""></van-image>
      </div>
      
      <div class="video" id="video" v-show="playId"></div>
      <div class="share" @click="show = true"  v-if="plat!=120">
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share_icon.png"
        />
        分享
      </div>
    </div>
    <van-tabs
      v-if="plat!=120"
      color="#A40001"
      line-width="75px"
      line-height="5px"
      title-active-color="#333"
      v-model="active"
      class="tab"
    >
      <van-tab title-class="tab-class" title="课程详情">
        <div
          class="tab-content"
          :style="{ paddingBottom: is_vip && !plat_vip.is_buy || !is_buy ? '200px' : '0' }"
        >
        
          <div class="vip-bar" v-if="is_vip && !plat_vip.is_buy && !is_buy" style="display:none"  @click="toPage('./vip/detailVIP?id='+plat_vip.goods_id)">
            去开通 <span>{{partalName}}VIP</span>，畅学万元课程
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_arrow.png"
              alt=""
            />
          </div>
          <!-- <div class="lesson-title">{{ name }}</div> -->
          <div class="lesson-img html-view" v-html="content_img"></div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="视频课程">
        <div
          class="tab-content"
          :style="{ paddingBottom: is_vip && !plat_vip.is_buy || !is_buy ? '200px' : '0' }"
        >
          <div class="vip-bar" v-if="is_vip && !plat_vip.is_buy && !is_buy" style="display:none" @click="toPage('./vip/detailVIP?id='+plat_vip.goods_id)">
            去开通 <span>{{partalName}}VIP</span>，畅学万元课程
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_arrow.png"
              alt=""
            />
          </div>
          <div class="lesson-list">
            <div
              class="lesson-item"
              :class="playId == item.value ? 'is_play' : ''"
              v-for="(item, index) of lessonList"
              :key="index"
              @click="playVideo($event, item)"
              :data-idx="index"
            >
              <div class="lesson-name ellipsis">
                {{ index + 1 }}. {{ item.lesson_name }}
                <img style="display: none;" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d7.png" />
              </div>
              <div class="free" v-if="plat!='120' && item.is_buy != 1 && item.is_show == 1">
                试看
              </div>
              <div class="lesson-msg">
                <div class="lesson-time">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d6.png"
                    alt=""
                  /><p>1学时</p>
                </div>
                <div class="lesson-time">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d5.png"
                    alt=""
                  />{{ item.resource[0].id || !item.resource[0].ali_media_id ? item.resource[0].ali_duration : item.resource[0].duration}}
                </div>
                <div class="lesson-count" v-if="plat!='120' && !item.is_buy && !item.is_show">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d3.png"
                    alt=""
                  />无权限
                </div>
                <div class="lesson-count" v-else-if="item.status==0" :style="{color: color[2]}">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d2.png"
                    alt=""
                  />未开始
                </div>
                <div class="lesson-status"  :style="{color: color[1]}"  v-if="item.status==2">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d1.png"
                    alt=""
                  />学习中
                </div>
                <div class="lesson-status"  :style="{color: color[0]}"  v-if="item.status==1">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d4.png"
                    alt=""
                  />已学完
                </div>
              </div>
            </div>
          </div>
          <div class="lesson-content html-view" v-html="content_app"></div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="课程考试" v-if="examinInfo && examinInfo.is_test">
        <div class="tab-content">
            <div  class="examin-content">
          <div class="examinLeft">
             <p class="examinTitle">{{ name }}考试试题</p> 
             <p class="examinDesc">满足课程的{{examinInfo.study_time}}学时即可参加考试</p>
             <p class="score"><span>满分{{examinInfo.score}}分</span>试题数{{examinInfo.question_number}}</p>
          </div>
          <div class="examinBtn" @click="toExamin" :class="{opacity:!examinInfo.study_pass}" v-if="!examinInfo.pass">开始考试</div>
        </div>
        </div>
        
      </van-tab>
      <!-- <van-tab title-class="tab-class" title="课程证书"  v-if="examinInfo && examinInfo.is_test">
        <div class="tab-content">
            <cert-save :lessonName="name" :userName="userName"></cert-save>
        </div>
        
      </van-tab> -->
    </van-tabs>
    <van-tabs
      v-else
      color="#A40001"
      line-width="75px"
      line-height="5px"
      title-active-color="#333"
      v-model="active"
      class="tab"
    >
      
      <van-tab title-class="tab-class" title="视频课程">
        <div
          class="tab-content"
          :style="{ paddingBottom: is_vip && !plat_vip.is_buy || !is_buy ? '200px' : '0' }"
        >
          <div class="vip-bar" v-if="is_vip && !plat_vip.is_buy && !is_buy" style="display:none" @click="toPage('./vip/detailVIP?id='+plat_vip.goods_id)">
            去开通 <span>{{partalName}}VIP</span>，畅学万元课程
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_arrow.png"
              alt=""
            />
          </div>
          <div class="lesson-list">
            <div
              class="lesson-item"
              :class="playId == item.value ? 'is_play' : ''"
              v-for="(item, index) of lessonList"
              :key="index"
              @click="playVideo($event, item)"
              :data-idx="index"
            >
              <div class="lesson-name ellipsis">
                {{ index + 1 }}. {{ item.lesson_name }}
                <img style="display: none;" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d7.png" />
              </div>
              <div class="free" v-if="plat!='120' && item.is_buy != 1 && item.is_show == 1">
                试看
              </div>
              <div class="lesson-msg">
                <div class="lesson-time">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d6.png"
                    alt=""
                  /><p>1学时</p>
                </div>
                <div class="lesson-time">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d5.png"
                    alt=""
                  />{{ item.resource[0].id || !item.resource[0].ali_media_id ? item.resource[0].ali_duration : item.resource[0].duration}}
                </div>
                <div class="lesson-count" v-if="plat!='120' && !item.is_buy && !item.is_show">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d3.png"
                    alt=""
                  />无权限
                </div>
                <div class="lesson-count" v-else-if="item.status==0" :style="{color: color[2]}">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d2.png"
                    alt=""
                  />未开始
                </div>
                <div class="lesson-status"  :style="{color: color[1]}"  v-if="item.status==2">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d1.png"
                    alt=""
                  />学习中
                </div>
                <div class="lesson-status"  :style="{color: color[0]}"  v-if="item.status==1">
                  <img
                    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/d4.png"
                    alt=""
                  />已学完
                </div>
              </div>
            </div>
          </div>
          <div class="lesson-content html-view" v-html="content_app"></div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="课程详情">
        <div
          class="tab-content"
          :style="{ paddingBottom: is_vip && !plat_vip.is_buy || !is_buy ? '200px' : '0' }"
        >
        
          <div class="vip-bar" v-if="is_vip && !plat_vip.is_buy && !is_buy" style="display:none"  @click="toPage('./vip/detailVIP?id='+plat_vip.goods_id)">
            去开通 <span>{{partalName}}VIP</span>，畅学万元课程
            <img
              src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_arrow.png"
              alt=""
            />
          </div>
          <!-- <div class="lesson-title">{{ name }}</div> -->
          <div class="lesson-img html-view" v-html="content_img"></div>
        </div>
      </van-tab>
      <van-tab title-class="tab-class" title="课程考试" v-if="examinInfo && examinInfo.is_test">
        <div class="tab-content">
            <div  class="examin-content">
          <div class="examinLeft">
             <p class="examinTitle">{{ name }}考试试题</p> 
             <p class="examinDesc">满足课程的{{examinInfo.study_time}}学时即可参加考试</p>
             <p class="score"><span>满分{{examinInfo.score}}分</span>试题数{{examinInfo.question_number}}</p>
          </div>
          <div class="examinBtn" @click="toExamin" :class="{opacity:!examinInfo.study_pass}" v-if="!examinInfo.pass">开始考试</div>
        </div>
        </div>
        
      </van-tab>
      <!-- <van-tab title-class="tab-class" title="课程证书"  v-if="examinInfo && examinInfo.is_test">
        <div class="tab-content">
            <cert-save :lessonName="name" :userName="userName"></cert-save>
        </div>
        
      </van-tab> -->
    </van-tabs>
    <!-- 到家高研院免费看视频 -->
    <div class="footer" v-if="plat!='120' && !is_buy">
      <div class="lesson" v-if="!is_buy" @click="goOrderMake">单课购买 ¥{{ price }}</div>
      <div class="vip"  v-if="is_vip && !plat_vip.is_buy" style="display:none" @click="toPage('./vip/detailVIP?id='+plat_vip.goods_id)">{{ partalName }}会员VIP</div>
    </div>
  </div>
</template>

<script>
import CertSave from './CertSave.vue';
export default {
  components: {CertSave},
  computed: {
    partalName() {
      return this.$store.state.plat.name;
    },
     plat() {
      return this.$store.state.plat_id
    },
    userName(){
      return JSON.parse(localStorage.getItem('userdata')).nickname
    },
    vipInfo(){
      return this.$store.state.vipInfo
    }
  },
  data() {
    return {
      show: false,
      show2: false,
      videoContext: "",
      active: -1,
      playId: 0,
      price: "",
      content_app: "",
      content_img: "",
      name: "",
      lessonList: [],
      is_buy: 0,
      is_vip: 0,
      is_free: 0,
      player: "",
      goods_sku_id: "",
      scrollLeft: "",
      examinInfo:null,
      currentInfo:null,
      plat_vip:null,
      duration:0,
      currentTime:'',
      totalTime:0,
      timeStart:0,
      cover:'',
      color: ['#666', '#FF4D41', '#6DD400'],
    };
  },
  watch:{
    active(e){
       if(e==1 && this.plat !='120' || e==0 && this.plat =='120'){
        this.playVideo("", this.lessonList[0])
       }else{
        console.log(this.player)
        if(this.player){
          this.totalTime =  parseInt(this.player.getDuration())
          this.currentTime = parseInt(this.player.getCurrentTime())
          this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
          this.player.dispose();
        }
        this.playId = null
        this.player = null
        this.addHistory()
       }
    }
  },
  async mounted() {
    this.active = this.$route.query.type=='video' ? 1 : 0
    let res = await this.$api({
      // url: "/api/goods/parent/lesson",
      url:"/api/platform/goods/detail",
      data: {
        goods_id: this.$route.query.id,
        plat:this.plat,
      },
    });
    if (res.code == 0) {
      console.log(res.data);
      let { is_buy,  goods_arr, list, base, plat_vip, cover } = res.data;
      this.cover = goods_arr[0].cover || this.$placeImg
      this.is_buy = is_buy;
      this.lessonList = list;
      this.examinInfo = base
      this.price = goods_arr[0].price;
      this.content_img = goods_arr[0].content_app;
      this.name = goods_arr[0].name;
      this.goods_sku_id = goods_arr[0].goods_sku_id;
      this.plat_vip = plat_vip;
      this.is_vip = goods_arr[0].is_vip_flat;
      this.is_free = goods_arr[0].is_free;
      let playList = list.filter((e) => {
        return e.is_show == 1;
      });
      if(this.$route.query.lessonId || this.plat==120){
        let info = this.lessonList.find(item=>item.lesson_id==this.$route.query.lessonId)
        this.playVideo("", info || list[0]);
      }
      // this.playVideo("", playList[0]);
      // this.playVideo("", list[0]);
    }
  },
  methods: {
    toPage(url){
      this.$router.push(url)
    },
    back() {
      this.$router.go(-1);
    },
    async playVideo($event, item) {
      if(!item) return
      if ($event) {
        this.scrollLeft = $event.currentTarget.offsetLeft;
      }
      if (item.value == this.playId) {
        return;
      }
      if (this.plat=='120'|| item.is_buy == 1 || item.is_show == 1) {
        this.playId = item.value;
        this.content_app = item.content_app;
        let id = item.resource[0].video_id;

        // 切换视频时记录上一个视频的观看时长
        if(this.player){
          this.totalTime =  parseInt(this.player.getDuration())
          this.currentTime = parseInt(this.player.getCurrentTime())
          this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
          this.addHistory()
        }
        

        this.currentInfo = item
        if (id) {
          let vid = id;
          let res = await this.$api({
            url: "/api/video/play-auth/get",
            data: {
              video_id: vid,
            },
          });
          if (res.code == 0) {
            // console.log(this.player, res.data);
          
            if (this.player) {
              this.player.dispose();
              // this.player.replayByVidAndPlayAuth({
              //   vid: res.data.videoId,
              //   playauth: res.data.playAuth,
              // });
              // return;
            }
            this.player = new Aliplayer(
              {
                id: "video",
                width: "100%",
                height: "100%",
                vid: res.data.videoId,
                playauth: res.data.playAuth,
              },
              function (player) {
                console.log("The player is created1.");
              }
            );
          }
        } else if(item.resource[0].ccid){
          let vid = item.resource[0].ccid;
          if (this.player) {
            this.player.changeVideo(vid);
            return;
          }
          console.log(vid);
          this.player = window.createCCH5Player({
            vid: vid,
            siteid: "23EEB4513490D389",
            autoStart: true,
            playertype: 1,
            isShare: "false",
            banDrag: "false",
            width: "100%",
            height: "100%",
            loop: "true",
            showFullScreenBtn: "false",
            useX5Play: "true",
            isShowUrlBtn: "false",
            isShowMoreBtn: "false",
            objectFit: "cover", // contain 、 fill 、 cover
            parentNode: ".video",
          });
        }else if(item.resource[0].url){
          if (this.player) {
              this.player.dispose();
              // this.player.replayByVidAndPlayAuth({
              //   vid: res.data.videoId,
              //   playauth: res.data.playAuth,
              // });
              // return;
          }
          this.player = new Aliplayer(
              {
                id: "video",
                width: "100%",
                height: "100%",
                autoplay : true,
                preload: true,
                source: item.resource[0].url,
                cover: item.resource[0].cover || this.cover
              },
              function (player) {
                console.log("The player is created2.");
                
              }
            );
        }else{
          if (this.player) {
              this.player.dispose();
          }
          this.$toast('当前没有视频')
        }
        this.player.on('play',()=>{
          this.timeStart = new Date()
        })
        this.player.on('pause',()=>{
          console.log('暂停')
          if(this.player){
            this.totalTime =  parseInt(this.player.getDuration())
            this.currentTime = parseInt(this.player.getCurrentTime())
            this.duration = this.timeStart ? parseInt((new Date().getTime() - this.timeStart.getTime()) / 1000) : 0
          }
          this.addHistory()
        })
      } else {
        this.content_app = item.content_app;
        this.$toast("请购买后开始学习")
      }
    },
    clickItem(e) {
      if (this.active != e.index) {
        this.active = e.index;
      }
    },
    goOrderMake() {
      if(!localStorage.getItem('userdata')){
        this.$toast("请登录后购买");
        return
      }
      if (this.goods_sku_id) {
        this.$router.push({
          path:'./order/make?goods_sku_id=' + this.goods_sku_id
        })
        // this.$store.dispatch("authJump", {
        //   path: "/pages/order/make",
        //   params: "goods_sku_id=" + this.goods_sku_id,
        // });
      }
    },
    videoErrorCallback: function (e) {
      uni.showModal({
        content: e.target.errMsg,
        showCancel: false,
      });
    },
    copy() {
      this.$copyText(String(window.location.href))
        .then((res) => {
          this.$toast("复制成功");
          this.show = false;
        })
        .catch((e) => {
          this.$toast("复制失败");
          this.show = false;
        });
    },
    toExamin(){
      if(this.examinInfo.study_pass){
        this.$router.push({
          path:'./examin',
          query:{
            id:this.examinInfo.test_id
          }
        })
      }else{
        this.$toast('您还未满足考试要求')
      }
      
    },
    async addHistory() {
     
      if(this.duration<5 || !this.currentInfo) return
      let data = this.currentInfo
      let res = await this.$api({
          method:'post',
          url:'/api/users/flat/record',
          data:{
          lesson_id: data.lesson_id,
          goods_course_id: data.goods_course_id,
          status: this.currentTime && this.currentTime===this.totalTime ? 1 : 0,
          duration: this.duration,
          flat_id: this.plat,
          playmode_id: data.id
        }
      })
      
      this.timeStart = 0
    },
  },
  beforeDestroy(){

  }
};
</script>

<style lang="scss">
.examin-content{
  display: flex;
  align-items: center;
  width: 9.2rem;
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
  margin-bottom: 0.26667rem;
  padding: 30px 20px;
  margin: 0.3rem auto;
}
.examin-content .examinBtn{
  text-align: center;
  padding: 10px 20px;
  background: rgb(164, 0, 1);
  color: #fff;
  border-radius: 5px;
}
.opacity{
  opacity: 0.5;
}
.examin-content .examinLeft{
  flex:1
}
.examin-content .examinLeft .examinTitle{
  color: #000;
  width: 100%;
  font-size: 34px;
  margin-bottom: 16px;
}
.examin-content .examinLeft .examinDesc{
  margin-bottom: 40px;
  font-size: 14px;
}
.examin-content .examinLeft .score{
  font-size: 14px;
}
.examin-content .examinLeft .score span{
   margin-right:50px
}
.detail-page {
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.video-wrap {
  width: 750px;
  height: 400px;
  position: relative;
}

.detail-page .video {
  width: 100%;
  height: 100%;
  background: #000;
}
.detail-page .price-cover{
  width: 100%;
}
.coverImg{
  position: relative;
  
    .tip{
      position: absolute;
      top:0px;
      left:0px;
      z-index: 1;
      img{
        width: 100px;
        // height: 35px;
      }
    }
}
.detail-page .share {
  position: absolute;
  right: 0;
  top: 37px;
  width: 109px;
  height: 52px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px 0 0 27px;
  color: #ddd;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.detail-page .share img {
  width: 24px;
  margin-right: 4px;
}

.detail-page .tab {
  width: 100%;
  height: calc(100vh - 400px - 92px);
  box-sizing: border-box;
}

.detail-page .van-tab--active {
  font-size: 34px !important;
}

.detail-page .tab-content {
  height: calc(100vh - 400px - 88px);
  background: #f7f8fa;
  width: 100vw;
  overflow-y: auto;
  box-sizing: border-box;
}

.detail-page .vip-bar {
  width: 690px;
  height: 100px;
  line-height: 100px;
  margin: 35px auto;
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_bg.png")
    no-repeat center;
  background-size: 100% 100%;
  font-size: 28px;
  color: #70481e;
  box-sizing: border-box;
  padding-left: 84px;
}

.detail-page .vip-bar span {
  font-size: 36px;
  font-weight: 600;
}

.detail-page .vip-bar img {
  float: right;
  width: 36px;
  margin-right: 32px;
  margin-top: 32px;
}

.detail-page .lesson-title {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  margin-top: 47px;
  padding: 0 35px;
  box-sizing: border-box;
}

.detail-page .lesson-list {
  width: 100vw;
  padding-left: 30px;
  box-sizing: border-box;
  margin-top: 35px;
}

.detail-page .lesson-img {
  width: 690px;
  margin: 24px auto;
}

.detail-page .lesson-item {
  width: 690px;
  height: 162px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 28px;
  position: relative;
}

.detail-page .lesson-msg {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  width: 100%;
}

.detail-page .lesson-msg .lesson-time,
.detail-page .lesson-msg .lesson-count,
.detail-page .lesson-msg .lesson-status {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  margin-right: 20px;
  white-space: nowrap;
}

.detail-page .lesson-msg img {
  height: 24px;
  margin-right: 11px;
}

.detail-page .lesson-name {
  padding: 5px 10px 8px;
  color: #000;
  font-size: 34px;
  margin-bottom: 16px;
  width: 100%;
}

.detail-page .free {
  width: 58px;
  height: 32px;
  background: #ff5d5e;
  border-radius: 16px 0 0 16px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 22px;
  position: absolute;
  right: 0px;
  top: 30px;
}

.detail-page .play {
  font-size: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-page .play img {
  height: 20px;
  margin-right: 10px;
}

.detail-page .time {
  width: 100%;
  font-size: 24px;
  text-align: right;
  box-sizing: border-box;
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: rgb(85, 85, 85);
}

.is_play .play,
.is_play .time,
.is_play .lesson-name {
  color: #a7090a;
}

.is_play .lesson-name img {
  display: block;
  width: 22px;
  height: 26px;
}

.detail-page .lesson-content {
  width: 690px;
  margin: 20px auto;
  color: #666666;
}

.detail-page .footer {
  width: 100%;
  height: 130px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px rgba(221, 217, 217, 0.5);
}

.detail-page .footer > .vip,
.detail-page .footer > .lesson {
  width: 332px;
  height: 90px;
  border-radius: 45px;
  border: 2px solid #a7090a;
  font-size: 34px;
  color: #a7090a;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.detail-page .footer .vip {
  background: #a7090a;
  color: #fff;
  margin-left: 28px;
}

.share-box {
  width: 750px;
  height: 164px;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box > div {
  margin: 0 65px;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box img {
  width: 94px;
  margin-right: 18px;
  font-size: 30px;
  color: #333;
}

.share-wrap {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.share-wrap img:last-of-type {
  width: 137px;
  position: absolute;
  right: 68px;
  top: 0;
}

.share-wrap img:first-of-type {
  width: 269px;
  position: absolute;
  right: 54px;
  top: 140px;
}
</style>
